import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PcgTableColumn } from '../pcg-table-column.interface';
import { ButtonFilterService } from './button-filter/button-filter.service';
import { DateRange } from 'app/shared/models/date-range';

@Component({
    selector: 'pcg-table-top',
    templateUrl: './table-top.component.html',
    styleUrls: ['./table-top.component.scss'],
    standalone: false
})
export class TableTopComponent implements OnInit {
	@Input() exactMatchSource: BehaviorSubject<boolean>;
	@Input() pageSizeSource: BehaviorSubject<number>;
	@Input() filterSource: BehaviorSubject<string>;
	@Input() pageLengths: [number];
	@Input() columnDefs: Map<string, PcgTableColumn>;
	@Input() canGlobalSearch = true;
	@Input() ajaxData: any;

	// Inputs for implementing the table dropdown filter features
	/** Filter ID to implement table dropdown filters. Passed from table component */
	@Input() filterId: string = null;
	/** Pass through a filtermap to show filters being utilized. Ex. src\app\shared\business-areas\order-list\order-list */
	@Input() filterMap: {} = null;
	/** Filters utilized for the table dropdown filters. Passed from table component */
	@Input() filters: any;
	/** Filter array for special reset button visibility behavior. Passed from table component */
	@Input() emptyFilters: {} = null;
	/** Whether the table dropdown filters have reset capabilities. Passed from table component*/
	@Input() canResetFilters = true;

	// Get a unique id to append to the id of controls to make it distinct
	// Doing this to have a distinct id to add to the for attribute of the exact match label
	uniqueId = `${new Date().getDay()}-${new Date().getSeconds()}-${new Date().getMilliseconds()}`;

	constructor(public btnFilterService: ButtonFilterService) {}

	ngOnInit() {
		if (this.canResetFilters) {
			this.emptyFilters ??= { ...this.filters };
		}
	}

	clearSearch(event) {
		setTimeout(() => {
			if (event.target.value == "") {
				this.filterSource.next("");
			}
		}, 1)
	}

	showResetFilterBtn() {
		return (
			this.canResetFilters &&
			Object.entries(this.filters).filter(
				([key, val]) =>
					key in this.emptyFilters &&
					!(
						this.emptyFilters[key] === val ||
						// Checking dateranges due to clearing range sets value to an object.
						(this.emptyFilters[key] instanceof DateRange &&
							this.emptyFilters[key].dateBegin === (val['dateBegin'] ?? null) &&
							this.emptyFilters[key].dateEnd === (val['dateEnd'] ?? null))
					)
			).length
		);
	}
}
